module.exports = __webpack_public_path__ + "img/icon-letter-h.513a5843.svg";